export default {
    URL_USER_LOGIN: 'user/login',
    URL_USER_FRESH: 'user/fresh',
    URL_USER_REGISTER: 'user/register',
    URL_USER_UPDATE: 'user/:userId',
    URL_USER_UPDATE_PASSWORD: 'user/:userId/change-password',

    URL_GEOCHEMISTRY_SOIL_A: 'TSM_Dat_A/:name/{z}/{x}/{-y}.png',
    URL_GEOCHEMISTRY_SOIL_C: 'dat_c/:name/{z}/{x}/{-y}.png',
    URL_GEOCHEMISTRY_SW: 'PNG_Nuoc_Mat/:name/{z}/{x}/{-y}.png',
    URL_GEOCHEMISTRY_GW: 'PNG_Nuoc_DD/:name/{z}/{x}/{-y}.png',
    URL_GEOCHEMISTRY_SEDIMENT: 'PNG_Tram_tich_dong/:name/{z}/{x}/{-y}.png',

    URL_METADATA_LEGEND: '_metadata/metadata_diahoa.csv',
}
